import { useMutation, useQueryClient } from "react-query";
import { createUserTask } from "api/users";
import { GET_USER_TASKS } from "@constants/reactQueryKeys";

/**
 * Custom hook for creating a new user task.
 *
 * @param {Object} options - Additional options for the mutation.
 * @returns {Object} - The result of the create task mutation.
 */
export const useCreateUserTask = (options = {}) => {
  const queryClient = useQueryClient();

  const {
    mutate: createTask,
    mutateAsync: createTaskAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
    ...rest
  } = useMutation(({ userId, taskData }) => createUserTask(userId, taskData), {
    onSuccess: (data, variables) => {
      // Invalidate and refetch user tasks to include the new task
      queryClient.invalidateQueries([GET_USER_TASKS, variables.userId]);
    },
    onError: (error) => {
      console.error("Error creating user task:", error);
    },
    ...options,
  });

  return {
    createTask,
    createTaskAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
    ...rest,
  };
};
